import filter from "../../../particles/filter";
import pagination from "../../../particles/pagination";
import showMore from "../../../particles/showMore";
import cart from "../../../particles/cart";

const bodyScrollLock = require('body-scroll-lock');

const app = {
  init: () => {
    app.mobilePopup()

    filter.init()

    pagination.init()
    showMore.init()
    cart.initCatalogItem()

    const filterInputs = document.querySelectorAll('.filter-block input')
    filter.changeInputs(filterInputs)

    const popupFilterLinks = document.querySelectorAll('.js_popup-filter')
    popupFilterLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault()

        filter.show(`#${link.dataset.popupFilter}`)
      })
    })
  },
  mobilePopup: () => {
    const popupBrandSubsections = document.getElementById('popup-brand-subsections');
    const brandSubsections = document.getElementById('brand-subsections');
    const popupFilterSorting = document.getElementById('popup-filter-sorting');
    const filterSorting = document.getElementById('filter-sorting');
    const popupCollections = document.getElementById('popup-filter-collections');
    const filterCollections = document.getElementById('filter-collections');
    const popupFilterClose = document.querySelectorAll('.popup-filter__close');

    const handler = () => {
      const sidebar = document.querySelector('.product-list__sidebar')
      if (popupBrandSubsections && brandSubsections) {
        if (window.innerWidth < 992 && !popupBrandSubsections.contains(brandSubsections)) {
          popupBrandSubsections.querySelector('.popup-filter__content').appendChild(brandSubsections)
          brandSubsections.querySelector('.filter-block__container').removeAttribute('style')
          brandSubsections.querySelector('.brand-products__filter-categories').classList.remove('js-hidden')
        }
        if (window.innerWidth >= 992 && popupBrandSubsections.contains(brandSubsections)) {
          sidebar.appendChild(brandSubsections)
        }
      }

      if (popupCollections && filterCollections) {
        const popupContent = popupCollections.querySelector('.popup-filter__content');

        const items = filterCollections.querySelectorAll('.item')

        if (window.innerWidth < 992 && !popupContent.childElementCount) {
          items.forEach((item) => {
            popupContent.appendChild(item)
          })
        }

        if (window.innerWidth >= 992 && popupContent.childElementCount > 0) {
          filterCollections.innerHTML = ''

          const popupItems = Object.values(popupContent.children)

          const createCol = () => {
            const newCol = document.createElement('div')
            newCol.classList.add('all-brand-col')

            return newCol
          }

          let col = createCol()
          let i = null

          for (const index in popupItems) {
            i = index % 3
            col.appendChild(popupItems[index])

            if (i === 2) {
              filterCollections.appendChild(col)
              col = createCol()
            }
          }

          if (i < 2) {
            filterCollections.appendChild(col)
          }
        }
      }

      if (popupFilterSorting && filterSorting) {
        if (window.innerWidth < 992 && !popupFilterSorting.contains(filterSorting)) {
          popupFilterSorting.querySelector('.popup-filter__content').appendChild(filterSorting)
        }
        if (window.innerWidth >= 992 && popupFilterSorting.contains(filterSorting)) {
          sidebar.appendChild(filterSorting)
        }
      }

      if (window.innerWidth >= 992) {
        const activePopup = document.querySelector('.popup-filter.js_active');
        if (activePopup) {
          activePopup.classList.remove('js_active')
          bodyScrollLock.clearAllBodyScrollLocks()
        }
      }
    }

    if (window.innerWidth < 992) {
      handler()
    }

    popupFilterClose.forEach((item) => {
      item.addEventListener('click', () => {
        item.closest('.popup-filter').classList.remove('js_active')
        bodyScrollLock.clearAllBodyScrollLocks()
      })
    })

    window.addEventListener('resize', handler)

    document.addEventListener('click', (e) => {
      const item = e.target

      const isSubmit = item.classList.contains('js_filter-panel-pin-btn') || item.closest('.js_filter-panel-pin-btn')

      if (!item.classList.contains('.item-checkbox') && !isSubmit) {
        let filterFoundPrev = document.querySelector('.filter-found-line')
        if (filterFoundPrev) {
          filterFoundPrev.parentNode.removeChild(filterFoundPrev)
        }
      }
    })
  },
}

export default app
